import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../http-error-handler.service';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EndpointLocationProviderService } from './endpoint-location-provider.service';

@Injectable()
export class ContatoComercialService {

    private env = environment;
    private handleError: HandleError;

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private endpointLocationService: EndpointLocationProviderService) {
        this.handleError = httpErrorHandler.createHandleError('ContatoComercialService');
    }

    getListContatoComercial(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_PARTNER)}/api/ContatoComercial/GetList/${this.env.SITE_ID}`)
            .pipe(
                catchError(this.handleError('Buscar Contato Comercial', []))
            );
    }
}
